import { defineComponent as l, openBlock as r, createBlock as a, unref as c, mergeProps as d, withCtx as s, createElementVNode as e } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const m = /* @__PURE__ */ l({
  name: "IconReassuranceShield36Months",
  __name: "IconReassuranceShield36Months",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, n) => (r(), a(c(p), d(t, { "view-box": "0 0 48 48" }), {
      default: s(() => [...n[0] || (n[0] = [
        e("path", { d: "M29 23.86a1.84 1.84 0 0 0 1.81-2 1.82 1.82 0 1 0-3.62 0 1.84 1.84 0 0 0 1.81 2" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M38 24.65c0 8.02-8.19 12.9-14 15.35-6.7-2.82-14-7.65-14-15.35V8h28v16.65m-5.13-7.55c-.12-1.709-1.418-2.998-3.765-3-2.677.002-4.385 1.812-4.415 5.79 0 3.83 1.63 5.7 4.31 5.7a3.77 3.77 0 0 0 4.11-3.78 3.44 3.44 0 0 0-3.51-3.7 3 3 0 0 0-2.64 1.39c.03-2.69.93-3.69 2.1-3.69a1.45 1.45 0 0 1 1.57 1.29h2.24M18.1 20.61h.61c1.36 0 2.12.45 2.14 1.59A1.68 1.68 0 0 1 19 23.86a1.71 1.71 0 0 1-1.9-1.65h-2.28c.03 2.07 1.54 3.38 4.18 3.38s4.08-1.44 4.08-3.38a2.61 2.61 0 0 0-1.95-2.61 2.46 2.46 0 0 0 1.7-2.4c0-1.63-1.24-3.1-3.83-3.1s-3.94 1.31-4 3.38h2.32A1.57 1.57 0 0 1 19 15.81a1.48 1.48 0 0 1 1.57 1.49c0 .96-.67 1.58-2.07 1.58h-.4v1.73",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M2 0v24.35C2 36.45 12.81 44.05 24 48c11.15-3.88 22-11.55 22-23.65V0H2m40 24.35c0 11-11.69 17-18 19.39C8.38 37.8 6 29.09 6 24.35V4h36v20.35",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  m as default
};
